const profiles = [
  {
    title: 'Interior Designers',
    description: 'Whether you\'re a solo practitioner or part of a multi-person firm, we give you trade access and procurement support that scales with your practice.',
    icon: 'ri-pencil-ruler-2-line',
    badge: 'Most Common'
  },
  {
    title: 'Design Firms',
    description: 'Larger studios benefit from our consolidated vendor relationships, volume pricing leverage, and dedicated account management.',
    icon: 'ri-building-4-line',
    badge: null
  },
  {
    title: 'Stagers & Stylists',
    description: 'Home stagers and stylists gain access to premium trade products at the pricing they need to stay competitive and profitable.',
    icon: 'ri-home-heart-line',
    badge: null
  }
];

export default function WhoWeServe() {
  return (
    <section className="py-28 bg-[#FAF8F5]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center mb-20">
          <div>
            <p className="text-[#C5A572] text-sm font-semibold uppercase tracking-widest mb-4">Our Clients</p>
            <h3 className="text-5xl font-bold text-[#2B2B2B] leading-tight">
              Who We<br />
              <span className="font-serif italic">Serve</span>
            </h3>
          </div>
          <div>
            <p className="text-gray-600 text-lg leading-relaxed">
              Design Assist is built exclusively for trade professionals. We don&apos;t serve the general public — which means every resource, every vendor relationship, and every service we offer is tailored specifically to your industry and your needs.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {profiles.map((p) => (
            <div key={p.title} className="bg-white rounded-3xl p-8 relative">
              {p.badge && (
                <div className="absolute top-5 right-5 bg-[#C5A572] text-white text-xs font-semibold px-3 py-1 rounded-full">
                  {p.badge}
                </div>
              )}
              <div className="w-14 h-14 bg-[#F5F0EB] rounded-2xl flex items-center justify-center mb-6">
                <i className={`${p.icon} text-[#C5A572] text-2xl`}></i>
              </div>
              <h4 className="text-lg font-bold text-[#2B2B2B] mb-3">{p.title}</h4>
              <p className="text-gray-500 text-sm leading-relaxed">{p.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
